import { r4Client, r4Error } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('EmailTemplateApi')

const EmailTemplateApi = {

  fetchEmailTemplates (params) {
    return new Promise((resolve, reject) => {
      r4Client()
        .get('/api/v1/email_templates', {
          params: params
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  createEmailTemplate (emailTemplateData) {
    return new Promise((resolve, reject) => {
      r4Client()
        .post('/api/v1/email_templates', emailTemplateData)
        .then(response => {
          logger.trace('CreateEmailTemplate: Success')
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  updateEmailTemplate (emailTemplateData) {
    return new Promise((resolve, reject) => {
      r4Client()
        .put(`/api/v1/email_templates/${emailTemplateData.id}`, emailTemplateData)
        .then(response => {
          logger.trace('UpdateEmailTemplate: Success')
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },

  // determines if create or update should be used
  saveEmailTemplate (emailTemplateData) {
    return new Promise((resolve, reject) => {
      let actionPromise = null
      if (emailTemplateData.id) {
        actionPromise = this.updateEmailTemplate(emailTemplateData)
      } else {
        actionPromise = this.createEmailTemplate(emailTemplateData)
      }
      actionPromise.then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(r4Error(error))
      })
    })
  },

  getEmailTemplate (emailTemplateId) {
    return new Promise((resolve, reject) => {
      return r4Client()
        .get(`/api/v1/email_templates/${emailTemplateId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  deleteEmailTemplate (emailTemplateId) {
    return new Promise((resolve, reject) => {
      return r4Client()
        .delete(`/api/v1/email_templates/${emailTemplateId}`)
        .then(() => {
          resolve('ok')
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  getStarterTemplate (starterTemplateName, templateType) {
    return new Promise((resolve, reject) => {
      return r4Client()
        .get('/api/v1/email_templates/template', { params: { name: starterTemplateName, type: templateType } })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  getMergeTags () {
    return new Promise((resolve, reject) => {
      r4Client()
        .get('/api/v1/mergetags')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  getSpecialLinks () {
    return new Promise((resolve, reject) => {
      r4Client()
        .get('/api/v1/mergetags/special_links')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },
  /**
   *
   * @param {*} options
   *   emailTemplateId
   *   rawHtml = false - do not merge - return raw html
   *   emailTemplateFooterId = the id of the footer to generate the preview with
   *
   */
  getHtmlPreview (options = {}) {
    const emailTemplateId = options.emailTemplateId
    const params = {
      raw_html: options.rawHtml || false
    }
    if (options.emailTemplateFooterId) {
      params.email_template_footer_id = options.emailTemplateFooterId
    }
    if (options.dealerId) {
      params.dealer_id = options.dealerId
    }
    if (options.rooftopId) {
      params.dealer_rooftop_id = options.rooftopId
    }

    return new Promise((resolve, reject) => {
      return r4Client()
        .get(`/api/v1/email_templates/${emailTemplateId}/preview`, { params: params })
        .then((resp) => {
          resolve(resp.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },

  getHtmlLiveView (options = {}) {
    const dealerId = options.dealerId
    const htmlTemplate = options.htmlTemplate
    const isCampaign = options.isCampaign
    const emailTemplateFooterId = options.emailTemplateFooterId
    const rooftopId = options.rooftopId

    return new Promise((resolve, reject) => {
      return r4Client()
        .post('/api/v1/email_templates/liveview', {
          template: htmlTemplate,
          email_template_footer_id: emailTemplateFooterId,
          dealer_id: dealerId,
          is_campaign: isCampaign,
          dealer_rooftop_id: rooftopId
        })
        .then((resp) => {
          resolve(resp.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  },

  getTemplateImageLocation () {
    return new Promise((resolve, reject) => {
      return r4Client()
        .get('/api/v1/email_templates/template_image_locations')
        .then((resp) => {
          resolve(resp.data)
        })
        .catch(error => {
          reject(r4Error(error))
        })
    })
  }
}

export default EmailTemplateApi
